angular
  .module('PartnersControllers', [])

  //config for /supports
  .config([
    '$routeProvider',
    function($routeProvider) {
      $routeProvider.when('/partners', {
        templateUrl: '/ng1/www/modules/partners/html/list.html',
        controller: 'PartnersListCtrl'
      });
    }
  ]);
